import axios from 'axios'
import MockAdapter from 'axios-mock-adapter'
import { sanitizeInput, generateUniqSerial } from 'Utility/globalMethods'

const defaultHeaders = {
  Accept: 'application/json, text/plain, */*',
  'cache-control': 'no-cache',
  Channel: 'web',
  'Client-Version': process.env.CLIENT_VERSION,
  'Content-Type': 'application/json',
  Env: process.env.DEPLOY_ENV_NAME,
  pragma: 'no-cache'
}

// Axios configuration
const axiosInstance = axios.create({
  withCredentials: true,
  baseURL: '',
  headers: {
    common: { ...defaultHeaders }
  }
})

// Add a request interceptor
axiosInstance.interceptors.request.use(
  (request) => {
    request.headers['Correlation-Id'] = generateUniqSerial()
    if (window.sessionStorage.getItem('jwt')) {
      request.headers.Authorization = JSON.parse(window.sessionStorage.getItem('jwt'))
    }
    request.data = sanitizeInput(request.data)
    return request
  },
  (error) => error
)

// Add a response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => error.response
)

const mockInstance = new MockAdapter(axiosInstance, { delayResponse: 1500 })

if (!process.env.ISMOCK) {
  mockInstance.onAny().passThrough()
} else {
  mockInstance.onGet(/^http:\/\/localhost:4001\/*/).passThrough()
  mockInstance.onPost(/^http:\/\/localhost:4001\/*/).passThrough()
}
export { defaultHeaders, mockInstance, axiosInstance }
